<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="giftName">
        <span slot="label"><a-tooltip>礼物名称<template slot="title">礼物名称</template></a-tooltip> </span>
        <a-input v-model="form.giftName" :maxLength="32" :placeholder="$t('请输入')+'礼物名称'">
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['giftName']"
            input-type="input"
            table-name="community_live_gift"
            table-field="giftName"
            :field-value="form.giftName"/>
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="giftPrice">
        <span slot="label"><a-tooltip>礼物价格<template slot="title">礼物价格</template></a-tooltip> </span>
        <a-input-number
          style="width: 100%"
          :min="0"
          :max="9999999"
          :step="1"
          v-model="form.giftPrice"
          :placeholder="$t('请输入')+'礼物价格'"/>
      </a-form-model-item>
      <a-form-model-item prop="picture">
        <span slot="label"><a-tooltip>图片<template slot="title">图片</template></a-tooltip> </span>
        <oss-upload-single :height="100" :width="100" v-model="form.picture" prefix="community" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="svgaUrl">
        <span slot="label"><a-tooltip>特效<template slot="title">特效</template></a-tooltip> </span>
        <oss-upload-single :height="100" :width="100" v-model="form.svgaUrl" prefix="community" type="svg"/>
      </a-form-model-item>
      <a-form-model-item prop="sort">
        <span slot="label"><a-tooltip>排序<template slot="title">排序</template></a-tooltip> </span>
        <a-input-number style="width: 100%" :min="0" :max="99999" v-model="form.sort" :placeholder="$t('请输入')+'排序'"/>
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label"><a-tooltip>状态<template slot="title">状态</template></a-tooltip> </span>
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label"><a-tooltip>备注<template slot="title">备注</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCommunityLiveGift, addCommunityLiveGift, updateCommunityLiveGift } from '@/api/community/liveGift'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    LocaleFieldButton,
    OssUploadSingle,
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        giftName: null,
        giftPrice: null,
        picture: null,
        svgaUrl: null,
        sort: null,
        status: true,
        remark: null,
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        giftName: [
          { required: true, message: '礼物名称' + this.$t('不能为空'), trigger: 'blur' }
        ],
        picture: [
          { required: true, message: '图片' + this.$t('不能为空'), trigger: 'blur' }
        ],
        giftPrice: [
          { required: true, message: '礼物价格' + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        giftName: null,
        giftPrice: null,
        picture: null,
        svgaUrl: null,
        sort: null,
        status: true,
        remark: null,
        localeFieldMap: {}

      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityLiveGift({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityLiveGift(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityLiveGift(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
